module.exports = __webpack_public_path__ + "static/media/logo-s.abd56807.png";